import { memo } from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@mui/styles";

import { Stepper, Step, StepLabel, StepConnector } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: "center",
    marginTop: theme.spacing(0),
    width: "100vw",
    marginLeft: -theme.spacing(2),
    marginBottom: theme.spacing(0),
    backgroundColor: "transparent",
    padding: theme.spacing(2),
  },
  stepIcon: {
    color: "white",
    border: "1px solid black",
    borderRadius: "100%",
  },
  activeIcon: {
    color: "white !important",
    border: "6.5px solid",
    borderColor: theme.palette.primary.main,
  },
  completeIcon: {
    color: `${theme.stepper.completed} !important`,
    border: "none",
  },
  textIcon: {
    fill: "none !important",
  },
  textColor: {
    color: theme.palette.primary.main,
  },
}));

const Connector = withStyles((theme) => ({
  root: {
    flex: "none",
  },
  active: {
    "& $line": {
      borderColor: theme.stepper.active,
    },
  },
  completed: {
    "& $line": {
      borderColor: theme.stepper.completed,
    },
  },
  line: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    width: 100,
    borderRadius: 1,
  },
}))(StepConnector);

const StepperTab = ({ steps = [], activeStep }) => {
  const classes = useStyles();
  return (
    <Stepper
      orientation="horizontal"
      activeStep={activeStep}
      connector={<Connector />}
      className={classes.root}
    >
      {steps.map((label, index) => {
        return (
          label !== false && (
            <Step key={`${label}-${index}`}>
              <StepLabel
                StepIconProps={{
                  classes: {
                    root: classes.stepIcon,
                    active: classes.activeIcon,
                    text: classes.textIcon,
                    completed: classes.completeIcon,
                  },
                }}
              >
                <span className={activeStep === index ? classes.textColor : ""}>
                  {label}
                </span>
              </StepLabel>
            </Step>
          )
        );
      })}
    </Stepper>
  );
};

StepperTab.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.array.isRequired,
};

export default memo(StepperTab);
